const style = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // padding: theme.spacing(2, 2, 0),
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    background: theme.palette.background.main,
    height: '100%',
    overflow: 'auto'
  }
});

export default style;
